import { SubmissionGroupEntityInterface } from '@types';

export type SubmissionGroupState = {
  submissionGroups: SubmissionGroupEntityInterface[];
  isCreating: boolean;
  isUpdating: boolean;
  isDeleting: boolean;
  submissionGroupsAll: SubmissionGroupEntityInterface[];
};
export const submissionGroupInitialState: SubmissionGroupState = {
  submissionGroups: [],
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
  submissionGroupsAll: [],
};
